export default "__VITE_ASSET__Dyyljpu5__"